import React, { useEffect, useState } from "react";
import { Zap, CheckCircle, Circle } from "lucide-react";
import axios from "axios";
import { IoMdCloseCircle } from "react-icons/io";

const RoleAssignModal = ({ setLoadStaffRoleModal, currentItem }) => {
  const [checkboxStates, setCheckboxStates] = useState(
    [
      "dashboard",
      // "electricity",i
      "bookings",
      "checkIn",
      "availability",
      "payments",
      "issues",
      "notice",
      "checkouts",
      "expenses",
      "reports",
      "resources",
      "staffs",
    ].map((each, index) => {
      return {
        name: each,
        checked: false,
        slideValue: 0,
      };
    })
  );

  const handleCheckboxChange = (index) => {
    const newStates = [...checkboxStates];
    const currentState = newStates[index];

    const newCheckedState = !currentState.checked;

    newStates[index] = {
      //   checked: newCheckedState,
      name: currentState.name,
      checked: newCheckedState,
      slideValue: newCheckedState ? 100 : 0,
    };

    setCheckboxStates(newStates);
  };

  //This function below fetches the user by id...
  useEffect(() => {
    const arrayObject = Object.keys(currentItem.permissions).map((each) => {
      return {
        name: each,
        checked: currentItem.permissions[each],
        slideValue: currentItem.permissions[each] ? 100 : 0,
      };
    });

    console.log("-----djfhjdhghdhj--", arrayObject);
    setCheckboxStates(arrayObject);
  }, []);

  //This function below updates the role permission of users
  const updateRole = () => {
    const transformedObject = checkboxStates.reduce((acc, curr) => {
      acc[curr.name] = curr.checked;
      return acc;
    }, {});
    console.log("i am new check box states--->", transformedObject);

    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/users/user-edit-profile/${currentItem._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        permissions: transformedObject,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      updateRole();
    }, 800); // Waits for 500ms of inactivity
    return () => clearTimeout(timeout);
  }, [checkboxStates]);

  return (
    <div className="flex items-center justify-center z-50  fixed inset-0 min-h-screen bg-[black]/10 backdrop-blur-sm p-4">
      <div className="bg-white relative  p-6  rounded-2xl shadow-2xl w-full max-w-6xl ">
        <div className="flex justify-between items-center mb-5">
          <p className="text-lg">
            <span>Staff Name: {currentItem.name}</span> <br />
            <span>Phone: {currentItem.phoneNumber}</span>
          </p>

          <IoMdCloseCircle
            size={65}
            onClick={() => {
              setLoadStaffRoleModal(false);
            }}
            className="px-4 py-2 text-primaryColor  font-semibold cursor-pointer rounded-md "
          />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {checkboxStates.map((state, index) => (
            <div
              key={index}
              className="relative bg-white rounded-xl shadow-md overflow-hidden"
            >
              <div
                className={`
                  absolute top-0 left-0 h-full 
                  bg-green-500/20 transition-all duration-500 ease-in-out
                `}
                style={{
                  width: `${state.slideValue}%`,
                  opacity: state.checked ? 1 : 0,
                }}
              />
              <div className="relative z-10 p-4">
                <div className="flex items-center justify-between mb-2">
                  <label className="text-gray-700 font-semibold capitalize">
                    {state.name}
                  </label>
                  <label className="relative inline-block w-16 h-8 cursor-pointer">
                    <input
                      type="checkbox"
                      className="opacity-0 w-0 h-0 peer"
                      checked={state.checked}
                      onChange={() => handleCheckboxChange(index)}
                    />
                    <span
                      className="absolute top-0 left-0 right-0 bottom-0 
                        bg-gray-300 rounded-full 
                        transition-all duration-300 
                        before:absolute before:content-[''] 
                        before:h-6 before:w-6 before:rounded-full 
                        before:bg-white before:top-1 before:left-1 
                        peer-checked:bg-green-500 
                        peer-checked:before:translate-x-8"
                    />
                  </label>
                </div>
                <div className="text-sm text-gray-600">
                  Status: {state.checked ? "Checked" : "Unchecked"}
                </div>
                {state.checked && (
                  <div
                    className="mt-2 h-2 bg-green-500 rounded-full transition-all duration-500"
                    style={{ width: `${state.slideValue}%` }}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoleAssignModal;
